import { render, staticRenderFns } from "./Kuluckasetler.vue?vue&type=template&id=1d2b690a&scoped=true"
import script from "./Kuluckasetler.vue?vue&type=script&lang=js"
export * from "./Kuluckasetler.vue?vue&type=script&lang=js"
import style0 from "./Kuluckasetler.vue?vue&type=style&index=0&id=1d2b690a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d2b690a",
  null
  
)

export default component.exports